var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit .mute-toggle {\n  background-image: url(" + escape(require("./ic_volume_up_white_24px.svg")) + ");\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  padding: 30px;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: 55%;\n  opacity: 0.5;\n  transition: opacity 0.125s ease;\n}\n\n#aa-video-ad-unit .mute-toggle:hover {\n  opacity: 0.8;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/Mute/Mute.css
// module id = 190
// module chunks = 6